export default __webpack_public_path__ + "static/media/1-cloudxier-PLN-highlightpreview.25b408b2.jpg";